import { MY_ACCOUNT } from "constants/routes";
import { checkAccess } from "helpers/auth";
import { serviceRoles } from "config/access";
import MyAccountPage from "./container/MyAccountPage";

export default function getRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.auth],
  };
  return {
    path: MY_ACCOUNT,
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    withSidebar: true,
    withAppBar: true,
    component: MyAccountPage,
  };
}
